/* import __COLOCATED_TEMPLATE__ from './comment-extra-quick-actions.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();